import { Injectable } from "@angular/core";

const STORAGE_KEY_ORIGIN = 'cross_auth_origin';
const STORAGE_KEY_ENABLED = 'cross_auth_enabled';
const STORAGE_KEY_TOKEN = 'cross_auth_token';

/**
 * Сервис для управления состоянием внешней авторизации (cross-auth).
 * Использует sessionStorage для хранения данных о внешнем приложении,
 * которое запрашивает авторизацию.
 */
@Injectable()
export class CrossAuthStateService {

  constructor() {}

  /**
   * Включить режим внешней авторизации и сохранить origin и токен отправителя
   * @param origin - источник запроса (origin внешнего приложения)
   * @param token - токен, полученный от внешнего сервиса
   */
  enableCrossAuth(origin: string, token: string): void {
    if (sessionStorage) {
      sessionStorage.setItem(STORAGE_KEY_ORIGIN, origin);
      sessionStorage.setItem(STORAGE_KEY_ENABLED, 'true');
      sessionStorage.setItem(STORAGE_KEY_TOKEN, token);
    }
  }

  /**
   * Отключить режим внешней авторизации
   */
  disableCrossAuth(): void {
    if (sessionStorage) {
      sessionStorage.removeItem(STORAGE_KEY_ORIGIN);
      sessionStorage.removeItem(STORAGE_KEY_ENABLED);
      sessionStorage.removeItem(STORAGE_KEY_TOKEN);
    }
  }

  /**
   * Получить токен внешней авторизации (из sessionStorage)
   */
  getCrossAuthToken(): string | null {
    if (sessionStorage) {
      return sessionStorage.getItem(STORAGE_KEY_TOKEN);
    }
    return null;
  }

  /**
   * Проверить, включен ли режим внешней авторизации
   */
  isCrossAuthEnabled(): boolean {
    if (sessionStorage) {
      return sessionStorage.getItem(STORAGE_KEY_ENABLED) === 'true';
    }
    return false;
  }

  /**
   * Получить origin отправителя запроса на авторизацию
   */
  getOrigin(): string | null {
    if (sessionStorage) {
      return sessionStorage.getItem(STORAGE_KEY_ORIGIN);
    }
    return null;
  }

  /**
   * Отправить сообщение внешнему приложению
   * @param message - сообщение для отправки
   * @param targetOrigin - конкретный origin для отправки (если null, используется '*')
   */
  sendMessage(message: any, targetOrigin: string | null = null): void {
    const origin = targetOrigin || '*';
    window.postMessage(message, origin);
  }
}
